export default "__VITE_ASSET__CrcIEwqx__"